import { useEffect, useState } from "react"
import { URL_BACKEND, URL_REPORTE_ASPIRANTE_POR_APLICACION } from "../../api/url"
import { elToast } from '../../functions/alertas'


const useReporteAspirantesExamen = () => {


    // variables
    const [datosAA, setDatosAA] = useState( [] )



    // funciones
    const traerAspirantesPorAplicacion = () => {

        let body = new FormData()
        body.append( 'funcion', 'aspirantePorAplicacion' )

        fetch( URL_BACKEND, {
            method: 'post',
            body
        })
        .then( r => r.json() )
        .then( d => {
            // console.log( d );s
            setDatosAA( d )
        })
    }

    const pluralSingular = ( cantidad ) => {

        if ( cantidad > 1 ) {
            return cantidad + " aspirantes"
        } else {
            return cantidad + " aspirante"
        }

    }

    const reporteAspirantePorAplicacion = (fecha) => {

        elToast( 'Generando reporte' )

        let body = new FormData()
        body.append( 'fecha', fecha );

        fetch( URL_REPORTE_ASPIRANTE_POR_APLICACION, {
            method: 'post',
            body
        })
        .then( r => r.blob() )
        .then( d => {

            let pdf = URL.createObjectURL( d );
            // window.open(pdf);

            var anchor = document.createElement("a");
            anchor.download = "Cantidad de aspirantes en la aplicación de " + fecha;
            anchor.href = pdf;
            anchor.click();

        })

    }



    // useEffect
    useEffect(() => {

        traerAspirantesPorAplicacion()

    }, [])




    return {
        datosAA,
        pluralSingular,
        reporteAspirantePorAplicacion
    }
}

export default useReporteAspirantesExamen
